/** Límite y tipos permitidos para el registro de asistencia de actividad grupal. */
export const MAX_ASISTENCIA_ACTIVIDAD_GRUPAL_MB = 5;

export const ASISTENCIA_ACTIVIDAD_GRUPAL_EXTENSIONS = ['jpg', 'jpeg', 'png', 'pdf'] as const;

/** Valor del atributo `accept` en inputs file (filtro en selector del SO). */
export const ASISTENCIA_ACTIVIDAD_GRUPAL_ACCEPT = '.pdf,.jpg,.jpeg,.png';

const MAX_BYTES = MAX_ASISTENCIA_ACTIVIDAD_GRUPAL_MB * 1024 * 1024;

function extensionDeNombreArchivo(filename: string): string {
  const name = filename.trim();
  const i = name.lastIndexOf('.');
  if (i <= 0 || i === name.length - 1) return '';
  return name.slice(i + 1).toLowerCase();
}

const ALLOWED_SET = new Set(ASISTENCIA_ACTIVIDAD_GRUPAL_EXTENSIONS.map((e) => e.toLowerCase()));

export function validateAsistenciaActividadGrupalFile(
  file: File
): { valid: true } | { valid: false; message: string } {
  const ext = extensionDeNombreArchivo(file.name);
  if (!ext || !ALLOWED_SET.has(ext)) {
    return {
      valid: false,
      message: `Solo se permiten archivos PDF, JPG o PNG.`,
    };
  }
  if (file.size > MAX_BYTES) {
    return {
      valid: false,
      message: `El archivo supera el tamaño máximo de ${MAX_ASISTENCIA_ACTIVIDAD_GRUPAL_MB} MB.`,
    };
  }
  return { valid: true };
}
